/**
 * Root layout — wraps every route with:
 *   - QueryClientProvider (TanStack Query)
 *   - I18nextProvider (react-i18next)
 *   - ToasterProvider + <Toaster /> (Radix toasts)
 *   - AuthBootstrap (hydrates the store on first mount)
 *
 * The actual shell (sidebar, top bar) lives under the
 * `_authenticated` layout — public routes (login, signup, etc.)
 * render bare.
 */
import { QueryClientProvider } from '@tanstack/react-query';
import { createRootRoute, Outlet } from '@tanstack/react-router';
import { I18nextProvider } from 'react-i18next';
import { Toaster, ToasterProvider } from '../components/ui/toast';
import { queryClient } from '../lib/api';
import { AuthBootstrap } from '../lib/auth-bootstrap';
import i18n from '../lib/i18n';

function RootLayout() {
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <ToasterProvider>
          <AuthBootstrap>
            <div className="flex min-h-screen flex-col bg-background text-foreground">
              <main className="flex-1">
                <Outlet />
              </main>
            </div>
            <Toaster />
          </AuthBootstrap>
        </ToasterProvider>
      </QueryClientProvider>
    </I18nextProvider>
  );
}

export const Route = createRootRoute({
  component: RootLayout,
});
